// TODO: Replace with the AI credit referral program terms URI.
/** Terms for the AI credit referral program, linked from the inviter and signup flows. */
export const REFERRAL_TERMS_URL = '/legal/tos'

/**
 * The referral program the file browser invites to. Hardcoded rather than read from
 * `exp_ai_credit_referrals`, because reading the experiment on the client would expose every user
 * to it; the server reads it once the user is eligible.
 */
export const AI_CREDIT_REFERRAL_PROGRAM_KEY = 'referral_v1'

export const AI_CREDIT_PROGRAMS_CONFIG = 'acquisition_ai_credit_programs_config'

export interface AiCreditReferralOfferTerms {
  maxInvites: number | null
  ownerCredits: number
  redeemerCredits: number
}

export type AiCreditReferralEntryPoint = 'file_browser'

export const AI_CREDIT_REFERRAL_DIALOG_ID = 'ai-credit-referral-dialog'
